import React, { useEffect } from 'react'
import { useLocation } from '@reach/router'

const removeMediavineAds = () => {
  const adhesion = document.querySelector('#adhesion_desktop_wrapper')
  removeElement(adhesion)

  const adhesionMobile = document.querySelector('#adhesion_mobile_wrapper')
  removeElement(adhesionMobile)

  const scripts = document.querySelectorAll('script[src*=mediavine]')
  scripts.forEach(removeElement)
}

const removeElement = element => {
  element && element.parentElement && element.parentElement.removeChild(element)
}

const removeFooterBranding = () => {
  const footer = document.querySelector('#footer_branding')
  footer && footer.parentElement && footer.parentElement.removeChild(footer)

  const body = document.querySelector('body')
  if (body.classList.contains('adhesion')) {
    body.classList.remove('adhesion')
  }
}

const MediavineBlocker = () => {
  const { pathname, search } = useLocation()
  useEffect(() => {
    removeFooterBranding()
    if (search.indexOf('a') === -1) removeMediavineAds()
  }, [pathname, search])

  return <div id="mediavine-settings" data-blocklist-all="1" />
}

export default MediavineBlocker
